import { createContext, useContext, useState, useCallback } from "react";
import { useConfig } from "@/context/ConfigContext";

const DemoContext = createContext(null);

export const useDemo = () => useContext(DemoContext);

export function DemoProvider({ children }) {
  const { config } = useConfig();
  const [launching, setLaunching] = useState(false);

  const launchDemo = useCallback(() => {
    const url = config?.crash_ready_demo_url;
    if (!url) return;
    if (config?.demo_transition_enabled === false) {
      window.location.href = url;
      return;
    }
    setLaunching(true);
    window.setTimeout(() => {
      window.location.href = url;
    }, 2200);
  }, [config]);

  return (
    <DemoContext.Provider value={{ launching, launchDemo }}>
      {children}
    </DemoContext.Provider>
  );
}
